<template>
  <p>{{ $t('appointment.error', { date: `${date}`}) }}</p>
</template>

<script>


export default {
    name: 'AppointmentError',
    data: () => ({
        date: '',
    }),
    created() {
        this.date = this.$attrs.date;
    },
};
</script>

<style lang="scss" scoped>

</style>
